/**
 * FH performance 2026-09-27: product photos load only for the colour being shown.
 * snippets/product-thumbnail.liquid (main gallery) and snippets/product-media.liquid (zoom pop-up) write the photo
 * address to data-fh-src / data-fh-srcset instead of src / srcset (except the product's first photo and the chosen
 * variant's photo), so the browser doesn't download every colour's photos when the page opens.
 * This file puts the real address back:
 *  - main gallery: when script.js's colour/size filter marks the slide with "slidefilterclass" (the photos shown);
 *    if the gallery is never filtered (2.5 s after the page is ready), all of its photos;
 *  - zoom pop-up: when it opens;
 *  - anywhere else: straight away.
 * Photos keep loading="lazy", so a shown colour's later photos still wait until they are about to be seen.
 * Rollback: remove the fh-deferred-media line in snippets/freshdesk.liquid and restore the two snippets.
 */
(function () {
  'use strict';
  if (window.__fhDeferredMedia) return;
  window.__fhDeferredMedia = true;

  var GRACE = 2500;
  var readyAt = document.readyState === 'loading' ? 0 : Date.now();
  var firstSeen = typeof WeakMap === 'function' ? new WeakMap() : null;
  var timer = 0;

  function load(img) {
    var src = img.getAttribute('data-fh-src');
    if (!src) return;
    var srcset = img.getAttribute('data-fh-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-fh-srcset');
    }
    img.setAttribute('src', src);
    img.removeAttribute('data-fh-src');
  }

  function scan() {
    timer = 0;
    var imgs = document.querySelectorAll('img[data-fh-src]');
    var now = Date.now();
    var retry = 0;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var modal = img.closest('product-modal');
      if (modal) {
        if (modal.hasAttribute('open')) load(img);
        continue;
      }
      var list = img.closest('.productmainslider');
      if (!list) {
        load(img);
        continue;
      }
      if (list.querySelector('.slidefilterclass')) {
        var slide = img.closest('.mainsliderproductslide');
        if (!slide || slide.classList.contains('slidefilterclass')) load(img);
        continue;
      }
      /* Not filtered (yet). Give script.js time to filter, then show everything in this gallery. */
      if (!readyAt) continue;
      var seen = firstSeen ? firstSeen.get(list) : 0;
      if (!seen) {
        seen = Math.max(now, readyAt);
        if (firstSeen) firstSeen.set(list, seen);
      }
      var wait = seen + GRACE - now;
      if (wait <= 0) load(img);
      else if (!retry || wait < retry) retry = wait;
    }
    if (retry) setTimeout(schedule, retry + 50);
  }

  function schedule() {
    if (!timer) timer = setTimeout(scan, 60);
  }

  function start() {
    if (!readyAt) readyAt = Date.now();
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  schedule();

  try {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'childList' ? r.addedNodes.length : true) {
          schedule();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
  } catch (e) {
    /* Very old browser: show everything. */
    readyAt = 1;
    GRACE = 0;
  }
})();
